import { getLogger } from "@expert/logging";
import { useQuery } from "@tanstack/react-query";
import { getChallengesForEmployee } from "@/sales-tools/challenges/api/getChallengesForEmployee";
import { usePartner } from "@/sdk";

const logger = getLogger({
    module: "useChallenges",
    supportTeam: "sales",
});

export const useChallenges = () => {
    const partner = usePartner();
    const { data, isLoading, isError, isFetching } = useQuery({
        queryKey: [`get-challenge`, partner],
        queryFn: async () => {
            logger.info({ partner }, "Fetching challenges for this participant");
            try {
                const result = await getChallengesForEmployee(partner);
                logger.info({ partner, challengeCount: result?.length ?? 0 }, "Successfully fetched challenges");
                return result;
            } catch (error) {
                logger.error({ error, partner }, "Failed to fetch challenges");
                throw error;
            }
        },
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: 1,
    });
    return { data, isLoading, isError, isFetching };
};
